var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArcade = function SvgArcade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm3.088-16.655c1.586 1.163 1.356 2.933.085 3.481a5.566 5.566 0 0 0-3.205-1.009 5.566 5.566 0 0 0-3.18.992c-1.236-.568-1.445-2.313.124-3.463C3.498 3.08 2.01 7.228 4.775 9.329a5.592 5.592 0 1 0 10.4.037c2.834-2.088 1.347-6.287-2.087-6.02Zm-3.12 11.496a3.431 3.431 0 1 0 0-6.863 3.431 3.431 0 0 0 0 6.863Z",
    clipRule: "evenodd"
  })));
};
export default SvgArcade;